import { render } from "./DDBurgerNav.vue?vue&type=template&id=1aca2ad4"
import script from "./DDBurgerNav.vue?vue&type=script&lang=js"
export * from "./DDBurgerNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__